import { Text } from '@radix-ui/themes';
import { Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';

interface Props extends TRuleEditorCommonProps {
  ruleIdx: number;
  name: ReactNode;
  onRemove: () => void;
  children: ReactNode;
}

const QuestionRule = ({ ruleIdx, isReadOnly, name, onRemove, children }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div className="rounded-md border p-2">
      <div className="group flex flex-row items-center gap-2 pt-2 pb-4">
        <Text className="whitespace-nowrap">{t('question.rules.ruleLabel', { index: ruleIdx + 1 })}</Text>
        {name}

        {!isReadOnly ? (
          <Trash2
            className="text-danger-400 h-4 w-4 shrink-0 cursor-pointer opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            onClick={onRemove}
          />
        ) : null}
      </div>

      {children}
    </div>
  );
};

export default QuestionRule;
